import { useLeaveWaitingRoomMutation } from '@/core/services/waiting-room'
import { getApiErrorMessage } from '@/utils/errors'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export function useLeaveWaitingRoom(waitingRoomId: string) {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const [leaveWaitingRoomMutation, { isLoading: isLeaving }] = useLeaveWaitingRoomMutation()

  const leaveWaitingRoom = async () => {
    if (!waitingRoomId) return

    try {
      await leaveWaitingRoomMutation(waitingRoomId).unwrap()
      navigate('/waiting-rooms')
    } catch (error) {
      enqueueSnackbar(getApiErrorMessage(error, t('notification.waitingRoom.leave.error')), { variant: 'error' })
    }
  }

  return { leaveWaitingRoom, isLeaving }
}
